import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import { TableHead, TableRow, TableData } from "./Styled";

const TableHeaders = ({ headerGroups }) => {
  return (
    <thead data-testid="table-header">
      {headerGroups.map((group, groupIndex) => (
        <TableRow key={groupIndex}>
          {group.headers.map((column, colIndex) => (
            <TableHead
              maxWidth={column.maxWidth}
              minWidth={column.minWidth}
              key={`${colIndex}-${groupIndex}`}
              {...column.getHeaderProps(
                column.sortable && column.getSortByToggleProps()
              )}
            >
              <TableData
                data-testid="header-cell"
                wordWrap={column.wordWrap}
                alignment={column.alignment}
                isSortedDesc={column.isSortedDesc}
                className={classnames({
                  headerCell: true,
                  isSorted: column.isSorted & column.sortable,
                  canSort: column.canSort && column.sortable
                })}
              >
                {column.render("Header")}
              </TableData>
            </TableHead>
          ))}
        </TableRow>
      ))}
    </thead>
  );
};

TableHeaders.propTypes = {
  headerGroups: PropTypes.arrayOf(
    PropTypes.shape({
      group: PropTypes.shape({
        headers: PropTypes.arrayOf(
          PropTypes.shape({
            maxWidth: PropTypes.number,
            minWidth: PropTypes.number,
            getHeaderProps: PropTypes.func,
            getSortByToggleProps: PropTypes.func,
            wordWrap: PropTypes.string,
            alignment: PropTypes.string,
            isSortedDesc: PropTypes.bool,
            isSorted: PropTypes.bool,
            canSort: PropTypes.bool,
            sortable: PropTypes.bool,
            render: PropTypes.func
          })
        )
      })
    })
  ).isRequired
};

export default TableHeaders;
